<script setup lang="ts">
  import { computed } from 'vue';
  import { type IllustrationName } from './Illustration.types';
  import { Picture } from '@/components';

  interface IllustrationProps {
    name: `${IllustrationName}`;
    lazy?: boolean;
  }

  const props = withDefaults(defineProps<IllustrationProps>(), {
    lazy: true,
  });
  const path = computed(() => `illustrations/${props.name}.png`);
</script>

<template>
  <Picture :path="path" :lazy="lazy" v-on="$listeners" />
</template>
